import { InternationalizationNameSpace } from 'core/models/internationalization-namespace';

const resources = {
  da: {
    [InternationalizationNameSpace.Assets]: () => import('feature/assets/locales/da.json'),
    [InternationalizationNameSpace.Auth]: () => import('feature/auth/locales/da.json'),
    [InternationalizationNameSpace.Companies]: () => import('feature/companies/locales/da.json'),
    [InternationalizationNameSpace.CookiePolicy]: () => import('feature/cookiepolicy/locales/da.json'),
    [InternationalizationNameSpace.Core]: () => import('core/locales/da.json'),
    [InternationalizationNameSpace.Dashboard]: () => import('feature/dashboard/locales/da.json'),
    [InternationalizationNameSpace.Faq]: () => import('feature/faq/locales/da.json'),
    [InternationalizationNameSpace.Maintenance]: () => import('feature/maintenance/locales/da.json'),
    [InternationalizationNameSpace.Map]: () => import('feature/map/locales/da.json'),
    [InternationalizationNameSpace.Changelog]: () => import('feature/changelog/locales/da.json'),
    [InternationalizationNameSpace.ThirdPartySoftware]: () => import('feature/thirdpartysoftware/locales/da.json'),
  },
  de: {
    [InternationalizationNameSpace.Assets]: () => import('feature/assets/locales/de.json'),
    [InternationalizationNameSpace.Auth]: () => import('feature/auth/locales/de.json'),
    [InternationalizationNameSpace.Companies]: () => import('feature/companies/locales/de.json'),
    [InternationalizationNameSpace.CookiePolicy]: () => import('feature/cookiepolicy/locales/de.json'),
    [InternationalizationNameSpace.Core]: () => import('core/locales/de.json'),
    [InternationalizationNameSpace.Dashboard]: () => import('feature/dashboard/locales/de.json'),
    [InternationalizationNameSpace.Faq]: () => import('feature/faq/locales/de.json'),
    [InternationalizationNameSpace.Maintenance]: () => import('feature/maintenance/locales/de.json'),
    [InternationalizationNameSpace.Map]: () => import('feature/map/locales/de.json'),
    [InternationalizationNameSpace.Changelog]: () => import('feature/changelog/locales/de.json'),
    [InternationalizationNameSpace.ThirdPartySoftware]: () => import('feature/thirdpartysoftware/locales/de.json'),
  },
  en: {
    [InternationalizationNameSpace.Auth]: () => import('feature/auth/locales/en.json'),
    [InternationalizationNameSpace.Assets]: () => import('feature/assets/locales/en.json'),
    [InternationalizationNameSpace.CookiePolicy]: () => import('feature/cookiepolicy/locales/en.json'),
    [InternationalizationNameSpace.Companies]: () => import('feature/companies/locales/en.json'),
    [InternationalizationNameSpace.Core]: () => import('core/locales/en.json'),
    [InternationalizationNameSpace.Maintenance]: () => import('feature/maintenance/locales/en.json'),
    [InternationalizationNameSpace.Dashboard]: () => import('feature/dashboard/locales/en.json'),
    [InternationalizationNameSpace.Dealers]: () => import('feature/dealers/locales/en.json'),
    [InternationalizationNameSpace.RoboticMowerCodes]: () => import('feature/roboticmower/locale/en.json'),
    [InternationalizationNameSpace.Faq]: () => import('feature/faq/locales/en.json'),
    [InternationalizationNameSpace.Map]: () => import('feature/map/locales/en.json'),
    [InternationalizationNameSpace.Changelog]: () => import('feature/changelog/locales/en.json'),
    [InternationalizationNameSpace.ThirdPartySoftware]: () => import('feature/thirdpartysoftware/locales/en.json'),
  },
  fi: {
    [InternationalizationNameSpace.Auth]: () => import('feature/auth/locales/fi.json'),
    [InternationalizationNameSpace.Assets]: () => import('feature/assets/locales/fi.json'),
    [InternationalizationNameSpace.CookiePolicy]: () => import('feature/cookiepolicy/locales/fi.json'),
    [InternationalizationNameSpace.Companies]: () => import('feature/companies/locales/fi.json'),
    [InternationalizationNameSpace.Core]: () => import('core/locales/fi.json'),
    [InternationalizationNameSpace.Maintenance]: () => import('feature/maintenance/locales/fi.json'),
    [InternationalizationNameSpace.Dashboard]: () => import('feature/dashboard/locales/fi.json'),
    [InternationalizationNameSpace.Dealers]: () => import('feature/dealers/locales/fi.json'),
    [InternationalizationNameSpace.Faq]: () => import('feature/faq/locales/fi.json'),
    [InternationalizationNameSpace.Map]: () => import('feature/map/locales/fi.json'),
    [InternationalizationNameSpace.Changelog]: () => import('feature/changelog/locales/fi.json'),
    [InternationalizationNameSpace.ThirdPartySoftware]: () => import('feature/thirdpartysoftware/locales/fi.json'),
  },
  fr: {
    [InternationalizationNameSpace.Assets]: () => import('feature/assets/locales/fr.json'),
    [InternationalizationNameSpace.Auth]: () => import('feature/auth/locales/fr.json'),
    [InternationalizationNameSpace.CookiePolicy]: () => import('feature/cookiepolicy/locales/fr.json'),
    [InternationalizationNameSpace.Core]: () => import('core/locales/fr.json'),
    [InternationalizationNameSpace.Companies]: () => import('feature/companies/locales/fr.json'),
    [InternationalizationNameSpace.Dashboard]: () => import('feature/dashboard/locales/fr.json'),
    [InternationalizationNameSpace.Faq]: () => import('feature/faq/locales/fr.json'),
    [InternationalizationNameSpace.Maintenance]: () => import('feature/maintenance/locales/fr.json'),
    [InternationalizationNameSpace.Map]: () => import('feature/map/locales/fr.json'),
    [InternationalizationNameSpace.Changelog]: () => import('feature/changelog/locales/fr.json'),
    [InternationalizationNameSpace.ThirdPartySoftware]: () => import('feature/thirdpartysoftware/locales/fr.json'),
  },
  it: {
    [InternationalizationNameSpace.Assets]: () => import('feature/assets/locales/it.json'),
    [InternationalizationNameSpace.Auth]: () => import('feature/auth/locales/it.json'),
    [InternationalizationNameSpace.Companies]: () => import('feature/companies/locales/it.json'),
    [InternationalizationNameSpace.Core]: () => import('core/locales/it.json'),
    [InternationalizationNameSpace.CookiePolicy]: () => import('feature/cookiepolicy/locales/it.json'),
    [InternationalizationNameSpace.Dashboard]: () => import('feature/dashboard/locales/it.json'),
    [InternationalizationNameSpace.Faq]: () => import('feature/faq/locales/it.json'),
    [InternationalizationNameSpace.Maintenance]: () => import('feature/maintenance/locales/it.json'),
    [InternationalizationNameSpace.Map]: () => import('feature/map/locales/it.json'),
    [InternationalizationNameSpace.Changelog]: () => import('feature/changelog/locales/it.json'),
    [InternationalizationNameSpace.ThirdPartySoftware]: () => import('feature/thirdpartysoftware/locales/it.json'),
  },
  ja: {
    [InternationalizationNameSpace.Assets]: () => import('feature/assets/locales/ja.json'),
    [InternationalizationNameSpace.Auth]: () => import('feature/auth/locales/ja.json'),
    [InternationalizationNameSpace.Changelog]: () => import('feature/changelog/locales/ja.json'),
    [InternationalizationNameSpace.Companies]: () => import('feature/companies/locales/ja.json'),
    [InternationalizationNameSpace.Core]: () => import('core/locales/ja.json'),
    [InternationalizationNameSpace.CookiePolicy]: () => import('feature/cookiepolicy/locales/ja.json'),
    [InternationalizationNameSpace.Dashboard]: () => import('feature/dashboard/locales/ja.json'),
    [InternationalizationNameSpace.Dealers]: () => import('feature/dealers/locales/ja.json'),
    [InternationalizationNameSpace.Faq]: () => import('feature/faq/locales/ja.json'),
    [InternationalizationNameSpace.Maintenance]: () => import('feature/maintenance/locales/ja.json'),
    [InternationalizationNameSpace.Map]: () => import('feature/map/locales/ja.json'),
    [InternationalizationNameSpace.ThirdPartySoftware]: () => import('feature/thirdpartysoftware/locales/ja.json'),
  },
  nl: {
    [InternationalizationNameSpace.Assets]: () => import('feature/assets/locales/nl.json'),
    [InternationalizationNameSpace.Auth]: () => import('feature/auth/locales/nl.json'),
    [InternationalizationNameSpace.Companies]: () => import('feature/companies/locales/nl.json'),
    [InternationalizationNameSpace.Core]: () => import('core/locales/nl.json'),
    [InternationalizationNameSpace.CookiePolicy]: () => import('feature/cookiepolicy/locales/nl.json'),
    [InternationalizationNameSpace.Dashboard]: () => import('feature/dashboard/locales/nl.json'),
    [InternationalizationNameSpace.Faq]: () => import('feature/faq/locales/nl.json'),
    [InternationalizationNameSpace.Maintenance]: () => import('feature/maintenance/locales/nl.json'),
    [InternationalizationNameSpace.Map]: () => import('feature/map/locales/nl.json'),
    [InternationalizationNameSpace.Changelog]: () => import('feature/changelog/locales/nl.json'),
    [InternationalizationNameSpace.ThirdPartySoftware]: () => import('feature/thirdpartysoftware/locales/nl.json'),
  },
  no: {
    [InternationalizationNameSpace.Maintenance]: () => import('feature/maintenance/locales/no.json'),
    [InternationalizationNameSpace.Map]: () => import('feature/map/locales/no.json'),
  },
  pl: {
    [InternationalizationNameSpace.Maintenance]: () => import('feature/maintenance/locales/pl.json'),
    [InternationalizationNameSpace.Map]: () => import('feature/map/locales/pl.json'),
  },
  sv: {
    [InternationalizationNameSpace.Assets]: () => import('feature/assets/locales/sv.json'),
    [InternationalizationNameSpace.Auth]: () => import('feature/auth/locales/sv.json'),
    [InternationalizationNameSpace.Core]: () => import('core/locales/sv.json'),
    [InternationalizationNameSpace.Companies]: () => import('feature/companies/locales/sv.json'),
    [InternationalizationNameSpace.CookiePolicy]: () => import('feature/cookiepolicy/locales/sv.json'),
    [InternationalizationNameSpace.Dashboard]: () => import('feature/dashboard/locales/sv.json'),
    [InternationalizationNameSpace.Faq]: () => import('feature/faq/locales/sv.json'),
    [InternationalizationNameSpace.Maintenance]: () => import('feature/maintenance/locales/sv.json'),
    [InternationalizationNameSpace.Map]: () => import('feature/map/locales/sv.json'),
    [InternationalizationNameSpace.Changelog]: () => import('feature/changelog/locales/sv.json'),
    [InternationalizationNameSpace.ThirdPartySoftware]: () => import('feature/thirdpartysoftware/locales/sv.json'),
  }
};

export { resources };
